import {
    MODAL_CLOSE,
    MODAL_LOADING_START,
    MODAL_LOADING_STOP,
    MODAL_OPEN,
} from 'store/actions/types';

export const openAlertModal = (payload) => {
    const {
        actions,
        content,
        title,
    } = payload;

    return {
        actions: actions || {},
        category: 'alert',
        content: content,
        modal: true,
        title: title,
        type: MODAL_OPEN,
    };
};

export const openConfirmModal = (payload) => {
    const {
        actions,
        content,
        title,
    } = payload;

    return {
        actions: actions || {},
        category: 'confirm',
        content: content,
        modal: true,
        title: title,
        type: MODAL_OPEN,
    };
};

export const closeModal = () => {
    return {
        type: MODAL_CLOSE,
    };
};

export const modalStartLoading = () => {
    return {
        type: MODAL_LOADING_START,
    };
};

export const modalStopLoading = () => {
    return {
        type: MODAL_LOADING_STOP,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/modalActions.js